import React, { useEffect, useState } from 'react'
import axios from '../services/axios'

export default function MessagesHistory() {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const handleDelete = async (id) => {
    await axios.delete(`/api/messages/${id}`)
    setItems(items.filter((item) => item.id !== id))
  }

  useEffect(() => {
    const load = async () => {
      setError('')
      setLoading(true)
      try {
        const { data } = await axios.get('/api/messages/history')
        setItems(data)
      } catch (e) {
        setError("Impossible de charger l'historique")
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  return (
    <div className="mx-auto max-w-7xl py-8">
      <h1 className="text-2xl font-bold mb-6">Historique des messages</h1>

      {error && (
        <div className="mb-4 rounded-md bg-red-50 p-3 text-sm text-red-700">{error}</div>
      )}

      {loading ? (
        <div>Chargement...</div>
      ) : (
        <div className="overflow-x-auto rounded-md border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Message original</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Message</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Infos</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 bg-white text-xs">
              {items.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50">
                  <td className="px-3 py-2 text-gray-700 max-w-xs whitespace-pre-wrap" title={row.message_origine}>{row.message_origine}</td>
                  <td className="px-3 py-2 text-gray-700 max-w-xs whitespace-pre-wrap" title={row.message}>{row.message}</td>
                  <td className="px-3 py-2 text-gray-700">rédigé le {new Date(row.created_at).toLocaleString()}<br />{row.bien_name}<br />{row.fullname}<br />{row.email}<br />{row.phonenumber}<br />{row.marketplace}<br />{row.journey}<br />{row.pax} adultes<br /><br/> Infos complémentaires : <br />{row.reason}</td>
                  <td className="px-3 py-2 text-gray-700">
                    <button className="hover:bg-red-700 bg-red-600 text-white px-4 py-2 rounded-md" onClick={() => handleDelete(row.id)}>Supprimer</button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr>
                  <td colSpan="4" className="px-3 py-6 text-center text-sm text-gray-500">Aucun message historisé</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}


